/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetProjectsWithCategoriesQueryResult } from '../../models/get-projects-with-categories-query-result';

export interface ApiProjectCategoriesGetProjectsWithCategoriesGet$Plain$Params {
  SearchTerm?: string;
}

export function apiProjectCategoriesGetProjectsWithCategoriesGet$Plain(http: HttpClient, rootUrl: string, params?: ApiProjectCategoriesGetProjectsWithCategoriesGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetProjectsWithCategoriesQueryResult>> {
  const rb = new RequestBuilder(rootUrl, apiProjectCategoriesGetProjectsWithCategoriesGet$Plain.PATH, 'get');
  if (params) {
    rb.query('SearchTerm', params.SearchTerm, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetProjectsWithCategoriesQueryResult>;
    })
  );
}

apiProjectCategoriesGetProjectsWithCategoriesGet$Plain.PATH = '/api/ProjectCategories/GetProjectsWithCategories';
